import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__copyright">
        Copyright @2026 Rekha Collection. All rights reserved
      </p>
    </footer>
  );
};

export default Footer;